<template>
    <el-dialog title="秘籍配置" :visible.sync="recipeDialog" width="1500px" :close-on-click-modal="false"
        :before-close="recipeDialogCancel" :open="open">
        <div>
            <div>
                <div>
                    <div class="recipeLine" v-for="option in recipeProp.recipeOptionList.recipeList">
                        <div class="recipeLineTitle">{{ option.name }}</div>
                        <el-checkbox-group v-model="option.selected" :min="0" :max="4">
                            <el-checkbox v-for="recipe in option.recipeOptional" :key="recipe.code"
                                :label="recipe.code" border>{{
                                    recipe.name }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="recipeDialogConfirm">确 定</el-button>
        </div>
    </el-dialog>

</template>

<script>


export default {
    props: {
        recipeProp: {
            recipeOptionList:{},
        },
    },
    name: "Recipe",
    data() {
        return {
            recipeDialog: false,
        }
    },
    methods: {
        init() {
        },
        open() {
            // 配置所有的缓存
            this.init();
            this.recipeProp.recipeOptionList;
            this.recipeDialog = true;
        },
        async recipeDialogConfirm() {
            this.$emit("confirm", this.select);
            this.recipeDialog = false;
            this.init();
        },
        async recipeDialogCancel() {
            this.recipeDialog = false;
            this.init();
        },
    },
    mounted() {
        this.init();
    }

}
</script>


<style lang="less" scoped>
.recipeLine {
    padding: 10px;
    margin-bottom: 15px;
    border: 1px solid;
    border-radius: 10px;
    display: flex;

    .recipeLineTitle {
        width: 100px;
        padding-right: 10px;
        font-size: 20px;
        font-weight: bold;
        color: rgb(211, 36, 36)
    }
}
</style>